// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"a403b339","760":"81e7a16f","774":"dbf6f850","787":"2e91bf4e","854":"0aae5722","966":"9703f61c"}[chunkId] + ".chunk.js";
};